import React, { useState } from 'react';
import { ColumnParams } from '../ColumnTemplate';

const ActionColumn = (props: ColumnParams) => {
    const [isChecked, setIsChecked] = useState(props.row.isBuyerSelected);
    return (
        props.row.isActive && (
            <input
                type="checkbox"
                checked={isChecked}
                className={props.readonly ? 'disabled' : ''}
                onChange={(event) => {
                    if (!props.readonly) {
                        setIsChecked(event.target.checked);
                        props.action?.(props.value, event.target.checked);
                    }
                }}
            />
        )
    );
};

export default ActionColumn;
